import React, { useEffect } from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import ErrorBoundary from 'components/ErrorBoundary';
import NotFound from 'pages/NotFound';
import SalonManagement from './pages/salon-management';
import BookingManagement from './pages/booking-management';
import SalonDashboard from './pages/salon-dashboard';
import UserProfile from './pages/user-profile';
import LoginIndex from 'pages/Auth/Index';
import PrivateRoute from 'PrivateRoutes';
import BodyFatCalculator from 'pages/test';
import MobileLayout from 'components/MobileLayout';

const AuthenticatedLayout = ({ children }) => {
  return <MobileLayout>{children}</MobileLayout>;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Route */}
          <Route path="/" element={<LoginIndex />} />

          {/* Protected Routes wrapped in mobile-first admin layout */}
          <Route
            path="/service-management"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <SalonManagement />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/test"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <BodyFatCalculator />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/salon-management"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <SalonManagement />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/booking-management"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <BookingManagement />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee-management"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <SalonManagement />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/availability-calendar"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <SalonManagement />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/salon-dashboard"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <SalonDashboard />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/user-profile"
            element={
              <PrivateRoute>
                <AuthenticatedLayout>
                  <UserProfile />
                </AuthenticatedLayout>
              </PrivateRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
